import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

import { selectCustomerDetails } from '@selectors/customerDetail';
import { selectGetEmail } from '@selectors/auth';
import { selectAddressApiToken } from '@selectors/addressApi';

import { checkIsStreetNumber } from '@utils/profileForms';

import {
  MOBILE_ORDER_FORM_STATE,
  profileDetailsToFormState,
} from '../../MobileOrderForm.helpers';

const useSyncUserDataWithFormState = (initialFormState, setInitFormState) => {
  const email = useSelector(selectGetEmail);
  const profileDetails = useSelector(selectCustomerDetails);
  const {
    query: { plan },
  } = useRouter();
  const addressApiToken = useSelector(selectAddressApiToken);
  const [isStreetNumberAvailable, setIsStreetNumberAvailable] = useState(true);

  useEffect(() => {
    checkIsStreetNumber(profileDetails?.personal?.address, addressApiToken, {
      zipCode: 'zipCode',
      street: 'street',
    }).then(isStreetNumber => {
      setIsStreetNumberAvailable(isStreetNumber);
    });
  }, [profileDetails, addressApiToken]);

  useEffect(() => {
    const initialStateFromLocalStorage = localStorage.getItem(
      `${MOBILE_ORDER_FORM_STATE}-PLAN-${plan}`,
    );
    const stateToCombine = initialStateFromLocalStorage
      ? JSON.parse(initialStateFromLocalStorage)
      : initialFormState;

    setInitFormState(
      profileDetailsToFormState(
        { email, mobile_plan: plan, ...profileDetails },
        stateToCombine,
        isStreetNumberAvailable,
      ),
    );
  }, [isStreetNumberAvailable, profileDetails, plan, email]);
};

export default useSyncUserDataWithFormState;
